export const CHAT_NEW_TICKET_STATES = {
  INITIAL: 'initial',
  CREATING: 'creating',
  FINISHED: 'finished',
};
